import React from "react";
import { Paper, Box, Popper, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { connect } from "react-redux";
import { homeActions } from "actions";
import HomeAutoCompleteView from "./HomeAutoCompleteView";
import LandingGauge from "./LandingGauge";

const HomeGaugeView = (props) => {
  const { organizationInfo } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesMinWidth = useMediaQuery("(max-width:500px)");
  
  const showGaugeFlag =
    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
    "y";
  const showProductDetailSelectionFlag =
    organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
    "y";
  const PopperView = (props) => {
    return (
      <Popper
        {...props}
        className="home-popper-view"
        style={{ width: matchesMinWidth ? "80vw" : "30rem" }}
        placement="bottom"
      />
    );
  };

  return (
    <Paper
      sx={{
        backgroundColor:
          organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor ||
          theme.palette.primary.main,
        height: !showGaugeFlag ? "400px" : matchesMinWidth ? "35vh" : "60vh",
        minHeight: matchesMinWidth ? "300px" : undefined,
        borderRadius: "20px",
        position: "relative",
        width: matchesSM ? "100vw" : undefined,
        borderBottomLeftRadius: matches ? 0 : undefined,
        borderBottomRightRadius: matches ? 0 : undefined,
      }}
    >
      <HomeAutoCompleteView
        customPopperView={PopperView}
        changeView
        isFromHomeGauge={true}
      />
      {showGaugeFlag || showProductDetailSelectionFlag ? (
        <Box
          id="search-container-box"
          sx={{
            height: "24vh",
            width: matchesMinWidth ? "280px" : "25rem",
            position: "absolute",
            top: matchesMinWidth ? "48%" : "50%",
            left: "50%",
            marginTop: "-12vh",
            marginLeft: matchesMinWidth ? "-140px" : "-12.5rem",
          }}
        >
          <LandingGauge />
        </Box>
      ) : null}
    </Paper>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    productsSearchList: state.productSearchList.data,
    recentList: state.recentSearch.data,
    isProgress: state.topProducts.isProgress,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getRecentSearch: () => homeActions.getRecentSearchList(),
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeGaugeView);
